import { useRouter } from 'vue-router';
const closeMenuMobile = () => {
  console.warn('closeMenuMobile');
  const overlayEl = document.getElementsByClassName('alt-submenu-overlay')[0];
  console.warn('overlayEl', overlayEl);
  if( typeof overlayEl != 'undefined' ) {
    overlayEl.addEventListener("click", toggleMenu );
  }
}

export const toggleMenu = (event: Event) => {
console.warn('toggleMenu');

  const body = document.body;
  const elMain = document.getElementById('alt-header-sp');
  const elUl = document.getElementById('alt-megamenu-sp');

  body.classList.toggle("alt-body-open-menu");

  if( elUl && ! body.classList.contains('alt-body-open-menu') ) {
    elUl.removeAttribute('style');
  }

  if( elMain ) {
    elMain.classList.toggle('open-menu');
    // elMain.style.height = "100%";
    // elMain.style.overflow = "auto";
  }

  if (elUl && elUl.classList.contains('open-submenu')) {
    elUl.classList.toggle('open-submenu');

  }

  const overlayEl = document.getElementsByClassName('alt-submenu-overlay')[0];
  if( typeof overlayEl != 'undefined' ) {
    setTimeout(function () {
      overlayEl.classList.toggle('show');
      const itemActive = document.querySelector('.alt-menu-item.active');
      if( itemActive ) {
        itemActive.classList.remove('active');
      }
    }, 100);
  }
  const countrySelector = document.querySelector(".country-selector_mobile");
  if( countrySelector ) {
    if (countrySelector.classList.contains('moved')){
      countrySelector.classList.remove('moved');
    }
  }
}

const router = useRouter();
const wooStore = useWooStore();
export const closeMenu = (event: Event, status:boolean) => {
    event.preventDefault();
  const body = document.body;
  const elMain = document.getElementById('alt-header-sp');
  const elUl = document.getElementById('alt-megamenu-sp');
  const overlayEl = document.getElementsByClassName('alt-submenu-overlay')[0];
  const countrySelector = document.querySelector(".country-selector_mobile");
    if(status){
        // Check if current path starts with /ms-my and maintain locale
        const currentPath = window.location.pathname;
        const targetUrl = currentPath.startsWith('/ms-my') ? '/ms-my' : '/';
        // console.log('targetUrl: ' + targetUrl);
        window.location.href = targetUrl;
        // if (window.location.pathname !== targetUrl) {
        //     window.location.href = targetUrl;
        // } else {
        //     router.push(targetUrl);
        // }
    }
  if (body.classList.contains("alt-body-open-menu")) {
    body.classList.remove("alt-body-open-menu");

    if (elMain) {
      elMain.classList.remove('open-menu');
      elMain.style.height = "";
      elMain.style.overflow = "";
    }

    if (elUl) {
      elUl.classList.remove('open-submenu');
      elUl.removeAttribute('style');
    }

    if (typeof overlayEl !== 'undefined') {
      overlayEl.classList.remove('show');
    }

    const itemActive = document.querySelector('.alt-menu-item.active');
    if (itemActive) {
      itemActive.classList.remove('active');
    }

    if (countrySelector && countrySelector.classList.contains('moved')) {
      countrySelector.classList.remove('moved');
    }
  }
};


export const jumpItem = (event: Event) => {
  const targetElement = event.target as HTMLElement;
  const elMain = document.getElementById('alt-megamenu-sp');
  event.preventDefault();
  if( elMain ) {
    // setTimeout(function () {
    //   elMain.style.height = "100%";
    // }, 100);
    elMain.classList.toggle('open-submenu');
    elMain.scrollTop = 0;
  }

  const countrySelector = document.querySelector(".country-selector_mobile");
  if( countrySelector ) {
    setTimeout(function () {
      countrySelector.classList.toggle('moved');
    }, 0);
  }

  const closestMenuItem = targetElement.closest('.alt-menu-item');
  if (closestMenuItem) {
    closestMenuItem.classList.toggle('active');

    const subMenu = closestMenuItem.querySelector('ul.alt-sub-megamenu');
    if (subMenu) {
      const subMenuHeight = subMenu.scrollHeight;
      if (subMenuHeight > 0 && elMain) {
        setTimeout(function () {
          elMain.style.height = subMenuHeight + 'px';
          elMain.style.overflow = 'hidden';
        }, 100);
      }
    }
  }
}

export const openSubItem = (event: Event) => {

  const targetElement = event.target as HTMLElement;
  const closestMenuItem = targetElement.closest('.alt-menu-has-submenu');
  const menuTitleClosest = targetElement.closest('.alt-mega-link');
  if( closestMenuItem ) {
    event.preventDefault();
    closestMenuItem.classList.toggle('active');
  }
  if( menuTitleClosest ) {
    menuTitleClosest.classList.toggle('active');
  }
}

export const backMenu = (event: Event, layout = 0 ) => {
    event.preventDefault();
    const el = event.target as HTMLInputElement;
    const elItem = el.closest('.alt-menu-item.active');
    if( elItem ) {
        elItem.classList.remove("active");

        const subEl = elItem.querySelector('.alt-menu-has-submenu.active');
        if( subEl ) {
          subEl.classList.remove("active");
        }

        const ulEl = document.querySelector('#alt-megamenu-sp.open-submenu');
        if( ulEl ) {
          ulEl.classList.remove("open-submenu");
        }

        const elMain = document.getElementById('alt-megamenu-sp');
        if( elMain ) {
          setTimeout(function () {
            elMain.style.height = '100%';
            elMain.style.overflow = 'auto';
          }, 0);
        }
        const countrySelector = document.querySelector(".country-selector_mobile");
        if( countrySelector ) {
          setTimeout(function () {
            countrySelector.classList.toggle('moved');
          }, 0);
        }
    }
}

export const toggleMenuBottom = (event: Event) => {
  event.preventDefault();

  const subMenuEl = document.querySelector('.alt-sub-megamenu-bottom');
  if( subMenuEl ) {
    subMenuEl.classList.toggle('active');
  }
}

export const handleWindowSizeChange = () => {
  if( window.innerWidth > 992) {
      return;
  }

  console.warn('handleWindowSizeChange');

  const overlayEl = document.getElementsByClassName('alt-submenu-overlay')[0];
  if( typeof overlayEl == 'undefined' ) {
      let element = document.createElement('div');
      element.classList.add('alt-submenu-overlay');
      document.body.append(element);

      closeMenuMobile();
  }
}
export const shopPopupSelectCountry = () => {
if( window.innerWidth > 1019) {
      return;
  }
  // console.log('mobilePopupSelectCountry');
   const altcsCurrencySelector = document.getElementById('alt-currency-selector');
   const altcsCurrencySelectors = document.getElementById('popup-overlay__country');
    if( altcsCurrencySelector ) {
        document.body.classList.remove('currency-popup-hidden');
        document.body.classList.add("currency-popup-show");
        altcsCurrencySelector.style.display = "flex";

    }
    if( altcsCurrencySelectors ) {

      altcsCurrencySelectors.classList.add('active');
      //  altcsCurrencySelectors.classList.remove('active');
    }
  }
export const closePopupSelectCountry = () => {
if( window.innerWidth > 1019) {
      return;
  }
   const altcsCurrencySelectors = document.getElementById('popup-overlay__country');

    if( altcsCurrencySelectors ) {

      // altcsCurrencySelectors.classList.add('active');
       altcsCurrencySelectors.classList.remove('active');
    }
}